/**
 * ProjectOriginService
 * Service for ProjectOrigin entity operations
 * Route: api/project-origins
 * Controller: ProjectOriginController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ProjectOriginService
 * Handles project origin CRUD operations
 * Maps to /api/project-origins endpoint
 */
export class ProjectOriginService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProjectOriginService.DEFAULT_SERVICE_PATH,
            basePath: ProjectOriginService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
ProjectOriginService.DEFAULT_SERVICE_PATH = 'projects';
ProjectOriginService.BASE_PATH = 'api/project-origins';
//# sourceMappingURL=ProjectOriginService.js.map